import { atom } from "recoil";

export const createDefaultWebhookBroadcastFormData = () => ({
	name: "",
	presetId: null,
	cohortConditions: [],
});

export const webhookBroadcastModalStore = atom({
	key: "webhookBroadcastModalStore",
	default: {
		show: false,
		loaded: true,
		formData: createDefaultWebhookBroadcastFormData(),
		audiencePreview: {
			loading: false,
			count: null,
			error: "",
		},
	},
});
